import SmartSelect from "../../../common/SmartSelect";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import { DateTimeFormatter, DateFormatter } from "../../../common/DateFormatterWithZone";
import { BooleanTextFormatter } from "../../../common/BooleanFormatter";

export const gridOptions = {
    suppressClickEdit: true,
    pagination: false,
    stopEditingWhenGridLosesFocus: true,
    autoSizeAllColumns: true,
    floatingFilter: true,
    enableRangeSelection: true,
    rowSelection: "single",
    rowGroupPanelShow: "always",
    suppressContextMenu: true,
    statusBar: {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left",
            },
            {
                statusPanel: "agAggregationComponent",
                statusPanelParams: {
                    aggFuncs: ["avg", "count", "min", "max", "sum"],
                },
            },
        ],
    },
    sideBar: {
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
        ],
        showToolPanel: false,
    },
    defaultColDef: {
        enableRowGroup: true,
        enablePivot: true,
        enableValue: true,
        sortable: true,
        filter: true,
        resizable: true,
    },
    frameworkComponents: {
        SmartSelect: SmartSelect,
        booleanCellEditor: CheckboxRenderer,
        dateTimeFormatter: DateTimeFormatter,
        dateFormatter: DateFormatter,
        booleanTextFormatter: BooleanTextFormatter,
    }
}

export const INITIAL_VALUES = '';
export const EDIT_USER = 'Edit User';
export const ADD_NEW_USER = 'Add New User';
export const EXPORT = 'Export';
export const REFRESH = 'Refresh';

//Error Messages
export const SAME_GRP_ERROR_MSG = 'This User already exists for the same Group, cannot add duplicate record'
export const DIFF_GRP_ERROR_MSG = 'This User is already active in another group, same user cannot be active in more than 1 group'